export default "__VITE_ASSET__BvZ93N_a__"